import { render } from "./ClimbingWallSection.vue?vue&type=template&id=1d514983"
import script from "./ClimbingWallSection.vue?vue&type=script&lang=js"
export * from "./ClimbingWallSection.vue?vue&type=script&lang=js"

import "./ClimbingWallSection.vue?vue&type=style&index=0&id=1d514983&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/mobil-maszofal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__